import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// 导入 Naive UI（完整引入方式，适合小型项目）
// 如果项目变大，可以改用按需引入以减少打包体积
import naive from 'naive-ui'

// 创建 Vue 应用实例
const app = createApp(App)

// 注册路由
app.use(router)

// 注册 Naive UI 组件库
app.use(naive)

// 挂载应用到 DOM
app.mount('#app')
